import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const GerenciarQuemSomos = () => {
  const [conteudo, setConteudo] = useState({
    titulo: '',
    descricao: '',
    conteudo: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchConteudo();
  }, []);

  const fetchConteudo = async () => {
    try {
      const response = await api.get('/api/site/quem-somos');
      if (response.data && response.data.titulo) {
        setConteudo({
          titulo: response.data.titulo || '',
          descricao: response.data.descricao || '',
          conteudo: response.data.conteudo || ''
        });
      }
    } catch (error) {
      console.error('Erro ao carregar conteúdo:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await api.put('/api/site/quem-somos', conteudo);
      toast.success('Conteúdo salvo com sucesso');
    } catch (error) {
      toast.error('Erro ao salvar conteúdo');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white">Gerenciar - Quem Somos</h1>
        <p className="text-white mt-1">Edite o conteúdo da página "Quem Somos"</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-sky-50 rounded-lg shadow p-6">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-800 mb-1">
              Título
            </label>
            <input
              type="text"
              value={conteudo.titulo}
              onChange={(e) => setConteudo({ ...conteudo, titulo: e.target.value })}
              className="w-full px-4 py-2 bg-white border border-sky-200 rounded-lg focus:ring-2 focus:ring-sky-400 focus:border-sky-400 text-gray-800"
              placeholder="Ex: Quem Somos"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-800 mb-1">
              Descrição (resumo)
            </label>
            <input
              type="text"
              value={conteudo.descricao}
              onChange={(e) => setConteudo({ ...conteudo, descricao: e.target.value })}
              className="w-full px-4 py-2 bg-white border border-sky-200 rounded-lg focus:ring-2 focus:ring-sky-400 focus:border-sky-400 text-gray-800"
              placeholder="Breve descrição que aparece no topo da página"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-800 mb-1">
              Conteúdo Completo
            </label>
            <textarea
              value={conteudo.conteudo}
              onChange={(e) => setConteudo({ ...conteudo, conteudo: e.target.value })}
              rows={12}
              className="w-full px-4 py-2 bg-white border border-sky-200 rounded-lg focus:ring-2 focus:ring-sky-400 focus:border-sky-400 text-gray-800"
              placeholder="Digite o conteúdo completo da página..."
            />
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <button
              type="submit"
              disabled={saving}
              className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors disabled:opacity-50"
            >
              {saving ? 'Salvando...' : 'Salvar Conteúdo'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GerenciarQuemSomos;
